export const storageParams = {
	accessToken: 'access-token'
};
